import { render, staticRenderFns } from "./ServiceProviderCategories.vue?vue&type=template&id=1417acbf&"
import script from "./ServiceProviderCategories.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports